export const Types = {
  SET_PHONE_QUEUES: "SET_PHONE_QUEUES",
  CALL_ENQUEUED: "CALL_ENQUEUED",
  CALL_DEQUEUED: "CALL_DEQUEUED"
};
export const setPhoneQueues = payload => ({
  type: Types.SET_PHONE_QUEUES,
  payload
});
